module.exports = __webpack_public_path__ + "media/images/number_10_green-f52a7d7ad7543191e4a00c3be043cc71.png";